<mat-accordion>
  <div mat-dialog-content class="dialog-content">
    <h4 mat-dialog-title>Session Manager Notification</h4>
   <br>
   <mat-label *ngIf="this.sessVals.sessionVals.result.length + 1 == this.sessVals.maxSession">The next session(s) are active in the system</mat-label>
   <mat-label *ngIf="this.sessVals.sessionVals.result.length + 1 > this.sessVals.maxSession">All available session for your user are used, please close some/all of them to continue</mat-label>
   <br>
   <br>
   <br>
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z3">
        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->           

      <!-- Symbol Column -->
      <ng-container matColumnDef="iat">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" ng-non-bindable> {{element.iat | date:'medium'}} </td>
      </ng-container>
      
       <!-- Symbol Column -->
  <ng-container matColumnDef="options">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button mat-flat-button color="warn" type="submit" (click)="closeThisSession(element.iat)">CLOSE</button>
    </td>
  </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <br>
    <br>
    <div mat-dialog-actions>
      <button mat-raised-button class= "alignleft" class="mat-raised-button" color="primary" (click)="cancelThisSession()">CANCEL THIS SESSION</button>     
      &nbsp;
      <button mat-raised-button *ngIf="this.sessVals.sessionVals.result.length + 1 <= this.sessVals.maxSession" class= "alignleft" class="mat-raised-button" color="primary" (click)="continueSession()">CONTINUE WITHOUT CLOSE</button>
      <button mat-raised-button *ngIf="this.sessVals.sessionVals.result.length + 1 > this.sessVals.maxSession" class= "alignleft" class="mat-raised-button" color="primary" (click)="closeAllValidSessions()">CLOSE ALL SESSIONS & CONTINUE</button>      
    </div>
    <!-- <div mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>     
    </div> -->
</mat-accordion>